<div class="row">
    <div class="col-md-4" *ngFor="let block of kpiData">
        <div class="card_gridTwo">
            <div class="row">
                <div class="col-md-4" *ngFor="let item of block.charts">
                    <div class="kpi-card">
                        <div class="kpi-title">{{ item.label }}</div>

                        <dx-chart [dataSource]="[{ name: '', value: item.value }]" [adaptiveLayout]="{ width: 0, height: 0 }">
                            <!-- SINGLE BAR SERIES -->
                            <dxi-chart-series argumentField="name" valueField="value" type="bar" [color]="block.color"> </dxi-chart-series>

                            <dxi-chart-value-axis
                                [visualRange]="{ startValue: 0, endValue: 100 }"
                                [visualRange]="{ startValue: 0, endValue: 100 }"
                                [tickInterval]="20"
                            >
                                <dxo-chart-label [customizeText]="customizeYAxisLabel" [visible]="true" [overlappingBehavior]="'none'"> </dxo-chart-label>
                            </dxi-chart-value-axis>
                            <dxo-argument-axis [visible]="false"></dxo-argument-axis>
                            <dxo-legend [visible]="false"></dxo-legend>
                            <dxo-tooltip [enabled]="true"></dxo-tooltip>
                        </dx-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
